require( 'intersection-observer' );
let element;

export default class TeaserSmall {
  constructor( node ) {
    this.node = node;
    element = node;

    window.addEventListener( 'load', () => {
      this.createIntersectionObserver();
      this.setStageHeight();
    });

    window.addEventListener( 'resize', () => {
      this.setStageHeight();
    });
  }

  setStageHeight() {
    var stageImgCnt = document.querySelector('.stage .stage__image-container-inner');

    // Remove the paddingTop for mobile devices.
    if (window.innerWidth <= 767) {
      stageImgCnt.style.paddingTop = '';
      return;
    }

    // Declare stage containers variables.
    var stageImgCntH = parseInt(stageImgCnt.offsetHeight),
        stageContentParentCntH = parseInt(document.querySelector('.stage .stage__content-container-inner').parentNode.offsetHeight),
        stageContentCntH = parseInt(document.querySelector('.stage .stage__content-container-inner').offsetHeight);

    // If stage content is higher then it's parent
    // or the difference between the parent and the image container is less then 100px.
    if (stageContentCntH >= stageContentParentCntH || (stageContentParentCntH - stageImgCntH <= 100)) {
      stageImgCnt.style.paddingTop = stageContentCntH + 300 + "px";
    }
  }

  handleIntersectionObserver( entries, observer ) {
    entries.forEach( entry => {
      if ( entry.isIntersecting ) {
        const img = entry.target.querySelector( 'IMG' );
        const video = entry.target.querySelector( 'IFRAME' );

        if ( img ) {
          if ( img.complete ) {
            element.classList.add( 'stage--fade-in' );
          } else {
            img.addEventListener( 'load', () => {
              element.classList.add( 'stage--fade-in' );
            });
          }
        }
        if ( video ) {
          const handleVideoLoad = () => {
            element.classList.add( 'stage--fade-in' );
          };
          if ( video ) {
            video.addEventListener( 'load', handleVideoLoad(), true );
          }
        }
        observer.unobserve( entry.target );
      }
    });
  }

  createIntersectionObserver() {
    let observer;
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: .25
    };

    observer = new IntersectionObserver( this.handleIntersectionObserver, options );
    observer.observe( this.node );
  }
}
